<template>
  <div class="coworker-search-page">
		<div class="subheader-wrapper">
      <div class="col" style="margin-left: -15px">
        <h2>Colleague Search</h2>
      </div>
      <div class="col" style="text-align: right" v-if="can('edit-colleagues')">
        <i class="fa fa-plus" @click="addNewColleague" aria-hidden="true" style="cursor:pointer"></i>
      </div>   
    </div>  

    <hr>
    <div class="full-screen-table">
      <BasicDataGrid
				v-if="!loading"
				gridRef="coworkerSearchGrid"
				:dataSource="coworkers"
				:dataGridKey="dataGridKey"
				:columns="columns"
				:multiSelect="false"
				noDataText="No colleagues found"
				:allowExport="false"
				:showColumnLines="true"
				:searchEntireGrid="false"
				@editColleague="editColleague"
				:actions="permissableActions"
			/>
    </div>

		<Modal ref="editColleagueModal">
			<EditColleagueForm v-model="editedColleague" @closeColleagueEdit="closeColleagueEdit" :title="editColleagueTitle"/>
		</Modal>

  </div>
</template>

<script>
import BasicDataGrid from '@/components/BasicDataGrid.vue';
import EditColleagueForm  from '@/components/EditColleagueForm.vue';
import Modal from '@/components/Modal.vue';
import { can } from '@/permissions.js'
import { CoworkerService } from '@/services';

export default {
  name: 'CoworkerSearch',
  components: {
    BasicDataGrid,
		EditColleagueForm,
		Modal
  },
  data() {
    return {
      loading: false,
      coworkers: [],
      dataGridKey: 'Id',
			editColleagueTitle: 'Edit Colleague',
			editedColleague: {},
			editColleagueModal: false,
      columns: [
        {text: 'Code', value:'Code', dataType: "string", width: '150px'}, 
        {text: 'First Name', value:'FirstName', dataType: "string"}, 
        {text: 'Last Name', value:'LastName', dataType: "string"}, 
        {text: 'Email', value:'Email', dataType: "string"}, 
        {text: 'Phone', value:'Phone', dataType: "string"}, 
        {text: 'Title', value:'Title', dataType: "string"}, 
        {text: 'Group', value:'GroupNames', dataType: "string"},
      ],
			actions:[
				{
					hint: 'Edit',
					icon: 'edit',
					emit: 'editColleague',
				},
			],
    };
  },
  computed: {
    permissableActions() {
      return can('edit-colleagues') ? this.actions : [];
    }
  },
  methods: {
    getCoworkers(){
      this.coworkers = CoworkerService.getDataSource(this.dataGridKey);
      // CoworkerService.all()
      //   .then(res => {
      //     this.coworkers = res.data.filter(coworker => {
      //       return !coworker.IsDeleted
      //     })
      //   })
      //   .catch(err => {
      //     console.log('err', err)
      //   })
    },
		addNewColleague(){
			this.editedColleague = {}
			this.editColleagueTitle = 'Add Colleague';
			this.toggleEditColleageModal()
		},
		editColleague(event){
      this.editedColleague = event.row.data
      this.editColleagueTitle = 'Edit Colleague';
      this.toggleEditColleageModal()
    },
		toggleEditColleageModal() {
			this.$refs.editColleagueModal.toggle()
		},
		closeColleagueEdit(data){
			if (this.editColleagueTitle.includes('Add')){ 
				CoworkerService.create(data)
				.then(res => {
					this.getCoworkers()
					this.toggleEditColleageModal()
				})
				.catch(err => {
					console.log('err', err);
					alert('Error creating coworker: ' + err)
				})
			} else {
				console.log('data', data);
				CoworkerService.update(data)
				.then(res => {
					this.getCoworkers()
					this.toggleEditColleageModal()
				})
				.catch(err => {
					console.log('err', err);
					alert('Error updating coworker: ' + err)
				})
			}
		}
	},
	created() {
		//console.log('created')
		this.getCoworkers()
	}
}

</script>
<style lang="scss" scoped>
  .coworker-search-page{
    // max-width: 1800px;
  }
  .btn-wrapper{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .btn {
      margin: 5px;
    }
  }
  .subheader-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-group{
      color: $primary;
      i{
        margin: 5px;
        cursor: pointer;
      }
    }
  }
</style>
